export default __webpack_public_path__ + "static/media/2 User.65741576.svg";